import * as Scrivito from "scrivito";

const InpageNavigationWidget = Scrivito.provideWidgetClass(
  "InpageNavigationWidget",
  {
    attributes: {
      elements: "referencelist",
      items: ["widgetlist", { only: "NavigationElementWidget" }], // this is for backwards compatibility, will be removed in the future
      childsFrom: "reference",
      direction: ["enum", { values: ["horizontal", "vertical"] }],
      internal: "boolean",
      sticky: "boolean",
      largeTopMargin: "boolean",
    },
  }
);

export default InpageNavigationWidget;
